// react-bootstrap imports
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import { BotaoVoltar } from "components/Helpers"

// components imports
import { LineWithText } from "components/FormGerarGuia"

import stdStyle from "json/StdStyles.json"
import modelDoc from "json/modelDoc.json"
import { BaixarDocFromID } from "services/CallAPIs"

// function MapSecIDToName(secID)
// {
//     if (!modelDoc[secID]) { return "SEÇÃO SEM NOME DEFINIDO (id = " + secID + ")"}

//     return modelDoc[secID].nome
// }

// function MapFieldIDToName(secID, fieldID)
// {
//     if (!secID || !fieldID) { return }
//     if (!modelDoc[secID]) { return }
//     if (!modelDoc[secID].campos[fieldID]) { return "CAMPO SEM NOME DEFINIDO (id = " + fieldID + ")"}

//     if (modelDoc[secID].campos[fieldID].hasOwnProperty("nome"))
//     {
//         return "Nome"
//     }

//     return modelDoc[secID].campos[fieldID]
// }

// const DocField = ({ sec, id, value }) =>
// {
//     if (!sec || !id || value === (undefined)) { return <></>}
    
//     // const arrayValues = Array.isArray(value) ? "" + value.map(val => val + "") : []
    
//     const ArrayValues = ({ value }) =>
//     {
//         if (!value || value.length <= 0) { return <></> }
        
//         const propertiesInsideTheObjects =
//         [
//             "matricula",
//             "classificacao",
//             "nome",
//             "taxInputs"
//         ]
//         let ehUmDosObjetosMapeados = false
//         propertiesInsideTheObjects.forEach(prop => { if (value[0].hasOwnProperty(prop)) { ehUmDosObjetosMapeados = true} })
        
//         if (!ehUmDosObjetosMapeados) { return <></> }

//         if (value[0].hasOwnProperty("matricula"))
//         {
//             return (
//                 <>
//                     <p className="fs-7">{value[0].nome}</p>
//                 </>
//             )
//         }

//         if (value[0].hasOwnProperty("classificacao"))
//         {
//             return (
//                 <>
//                     <p className="fs-7">{value[0].qtd}</p>
//                 </>
//             )
//         }

//         if (value[0].hasOwnProperty("nome"))
//         {
//             return (
//                 <div className="d-flex flex-column align-items-start">
//                     {value.map((val, index) => {
//                         return (
//                             <div key={val + index}>
//                                 <p></p>
//                                 <p className="fs-7">{value[0].nome}</p>
//                                 <p className="fs-7">{value[0].tipo}</p>
//                                 <p className="fs-7">{value[0].creaCau}</p>
//                             </div>
//                     )})}
//                 </div>
//             )
//         }

//         if (value[0].hasOwnProperty("taxInputs"))
//         {
//             return (
//                 <>
                    
//                 </>
//             )
//         }

//         if (!Array.isArray(value[0]))
//         {
//             return (
//                 <div className="d-flex flex-column align-items-start">
//                     <p></p>
//                     {value.map((val, index) => <p className="fs-7" key={val + index}>{val}</p>)}
//                 </div>
//             )
//         }

//         return <></>

//         // Array dupla
//         // return value.map((val, index) => {
//         //     return (
//         //         <div key={val + index}>
//         //             Oi
//         //         </div>
//         //     )
//         // })
//     }

//     function isObject(value) { return typeof value === 'object' && !Array.isArray(value) && value !== null }
    
//     return (
//         <div className="d-flex my-2" key={id}>
//             <p className="fw-bold mx-2 fs-7">{MapFieldIDToName(sec, id)}{":"}</p>
//             {
//                 Array.isArray(value)
//                 ? <ArrayValues value={value} />
//                 : ( !isObject(value) ? <p className="fs-7">{value}</p> : <></> )
//             }
//         </div>
//     )
// }

// function DisplayFieldValues(sectionKey, sectionFieldsData)
// {

//     if (!sectionFieldsData) { return <></>}

//     const fieldIDs = Object.keys(sectionFieldsData)
//     return fieldIDs.map(fieldID => sectionFieldsData[fieldID] ? <DocField sec={sectionKey} id={fieldID} value={sectionFieldsData[fieldID]} key={fieldID} /> : <div key={fieldID}></div>)
// }

// function DisplaySection({ sectionKey, sectionData })
// {
//     if (!sectionKey || !sectionData)  { return <></>}
    
//     if (typeof sectionData !== "object")
//     {
//         return <DocField id={sectionKey} value={sectionData} />
//     }

//     return (
//         <>
//             <LineWithText text={MapSecIDToName(sectionKey)} align="Left" color={"text-primary"}/>
//             {Array.isArray(sectionData) ? sectionData.map(item => DisplayFieldValues(sectionKey, item)) : DisplayFieldValues(sectionKey, sectionData)}
//         </>
//     )
// }

// function DateToString(date)
// {
//   const day = date.substring(8,10)
//   const month = date.substring(5,7)
//   const year = date.substring(0,4)
//   return day + "/" + month + "/" + year
// }

// function formatDocInfo(docData)
// {
//     let docInfo = {}
    
//     docInfo["docInfo"] =
//     {
//         proc: docData.numProc + " / " + docData.anoProc,
//         createdAt: DateToString(docData.createdAt),
//         fatoGerador: docData.fatoGerador,
//     }
//     docInfo = Object.assign(docInfo, docData)

//     delete docInfo["createdAt"]
//     delete docInfo["fatoGerador"]

//     return docInfo
// }

export function VerDocumentoScreen()
{
    const location = useLocation()
    const procData = location.state.procData
    const docData = location.state.docData
    const [pdfUrl, setPdfUrl] = useState()
    
    useEffect(() => {
        async function fetchProcesso()
        {
            const pdfData = await BaixarDocFromID(procData.id, docData.id, "", false)
            const file = new Blob([pdfData], {type: 'application/pdf'})
            const url = window.URL.createObjectURL(file)
            // window.open(url)
            setPdfUrl(url)
        }
        fetchProcesso()
    }, [procData, docData])

    
    // const {linkPrevPage, statePrevPage} = location.state
    // const docDataFormatted = formatDocInfo(docData)
    // const sectionKeys = Object.keys(docDataFormatted)
    
    // return (
    //     <div className={stdStyle.form}>
    //         <p className = "fw-bold mt-3 align-self-center">Informações do documento</p>
    //         <hr />
    //         <p className = "text-danger">Página em construção, podem faltar algumas informações</p>
    //         <hr />
    //         <p className = "fw-bold mt-3 align-self-center">{docData.tipoDoc + " N° " + docData.numDoc + "/" + docData.anoDoc}</p>
    //         {sectionKeys.map(key => <DisplaySection key={key} sectionKey={key} sectionData={docDataFormatted[key]}/>)}
    //         <BotaoVoltar linkPrevPage={linkPrevPage} statePrevPage={statePrevPage} />
    //     </div>
    // )
    return (
        <div className="d-flex flex-grow-1 container mb-3" >
            { pdfUrl !== undefined ? <embed src={pdfUrl} className="flex-grow-1" height="600px"></embed> : <></>}
        </div>
    )
}